import React from 'react';
import ReactDOM from 'react-dom';
import './styles/tailwind.generated.css';
import './index.css';
import { purgeLegacyAuthStorage } from './config/api-config';
import { ConfigProvider } from './context/ConfigContext';
import { AuthProvider } from './context/AuthContext';
import App from './App';

purgeLegacyAuthStorage();

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <ConfigProvider>
        <App />
      </ConfigProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
